/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindMappingByTypeQueryResponse,
  FindMappingByTypePathParams,
  FindMappingByTypeQueryParams,
} from "../types/FindMappingByType.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findMappingByTypeQueryKey = (
  type: FindMappingByTypePathParams["type"] | undefined,
  params: FindMappingByTypeQueryParams
) =>
  [
    {
      url: "/v1/client-settings/find-mapping-by-type/:type",
      params: { type: type },
    },
    ...(params ? [params] : []),
  ] as const

export type FindMappingByTypeQueryKey = ReturnType<
  typeof findMappingByTypeQueryKey
>

/**
 * @summary Find mapping by type
 * {@link /v1/client-settings/find-mapping-by-type/:type}
 */
export async function findMappingByType(
  type: FindMappingByTypePathParams["type"],
  params: FindMappingByTypeQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindMappingByTypeQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-settings/find-mapping-by-type/${type}`,
    params,
    ...requestConfig,
  })
  return res
}

export function findMappingByTypeQueryOptions(
  type: FindMappingByTypePathParams["type"] | undefined,
  params: FindMappingByTypeQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findMappingByTypeQueryKey(type, params)
  return queryOptions<
    ResponseConfig<FindMappingByTypeQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindMappingByTypeQueryResponse>,
    typeof queryKey
  >({
    enabled: !!type,
    queryKey,
    queryFn: async ({ signal }) => {
      return findMappingByType(type!, params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find mapping by type
 * {@link /v1/client-settings/find-mapping-by-type/:type}
 */
export function useFindMappingByType<
  TData = ResponseConfig<FindMappingByTypeQueryResponse>,
  TQueryData = ResponseConfig<FindMappingByTypeQueryResponse>,
  TQueryKey extends QueryKey = FindMappingByTypeQueryKey,
>(
  type: FindMappingByTypePathParams["type"] | undefined,
  params: FindMappingByTypeQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindMappingByTypeQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findMappingByTypeQueryKey(type, params)

  const query = useQuery(
    {
      ...findMappingByTypeQueryOptions(type, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
